import React, { useEffect, useState } from 'react';

export interface IWidthContext {
    width: number;
}

const getWidth = () => {
    const innerWidth = window.innerWidth;
    const clientWidth = document.documentElement?.clientWidth || 0;

    if (innerWidth > 0 && clientWidth > 0) {
        return Math.min(innerWidth, clientWidth);
    }

    // SSR/jsdom can report clientWidth as 0. Fall back to whichever width is positive.
    return Math.max(innerWidth, clientWidth, 0);
};

export const WidthContext = React.createContext<IWidthContext>({
    width: 0,
});

/**
 * Returns the current view width
 *
 * Example: const {width} = useWidthContext() will give you a number
 * variable that subscribes to window resizes and updates accordingly
 */
export const useWidthContext = () => React.useContext(WidthContext);

export function WidthContextProvider(props: any) {
    const [width, setWidth] = useState(getWidth());

    useEffect(() => {
        const windowResizeListener = () => {
            setWidth(getWidth());
        };

        window.addEventListener('resize', windowResizeListener);

        return () => {
            window.removeEventListener('resize', windowResizeListener);
        };
    }, []);

    return (
        <WidthContext.Provider value={{ width }}>
            {props.children}
        </WidthContext.Provider>
    );
}
